import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AgPromise, IDoesFilterPassParams, IFilterParams, RowNode } from 'ag-grid-community';
import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';


@Component({
    selector: 'app-date-filter',
    templateUrl: './date-filter.component.html',
    styleUrls: ['./date-filter.component.scss'],
    standalone: false ,  // NOSONAR
})
export class DateFilterComponent implements IFilterAngularComp, OnInit {
	private params: IFilterParams;
	private valueGetter!: ValueGetterFunc<any>;
	public text: string = '';
	public hideFilter;
	selectedFromDate;
	selectedToDate;


	@ViewChild('input', { read: ViewContainerRef }) public input;

	agInit(params: IFilterParams): void {
		this.params = params;
		const valueGetter = params.colDef.valueGetter;
  
		if (typeof valueGetter == 'function') { // NOSONAR
		  this.valueGetter = valueGetter;
		} else if (typeof valueGetter == 'string') { // NOSONAR
		  // Convert string to a function that returns the corresponding field value
		  const fieldName = valueGetter;
		  this.valueGetter = (params) => params.data[fieldName];
		} else {
		  // fallback to a simple function returning null or undefined
		  this.valueGetter = () => null;
		}
	  }

	isFilterActive(): boolean {
		return this.text != null && this.text != ''; // NOSONAR
	}

	afterGuiAttached(params) {
		this.hideFilter = params.hidePopup
	}
	
	closeDialog() {
		this.hideFilter();
	}
	constructor(public dialog: MatDialog) { }
	getModel() {
		return true;
	}
	setModel(model: any): void | AgPromise<void> {
		return;
	}
	refresh?(newParams: IFilterParams): boolean {
		return true;
	}
	doesFilterPass(params: IDoesFilterPassParams): boolean {
		return true;
	}
	afterGuiDetached?(): void {
		return;
	}
	onNewRowsLoaded?(): void {
		return;
	}
	onAnyFilterChanged?(): void {
		return;
	}
	getModelAsString?(model: any): string {
		return;
	}
	ngOnInit(): void { // NOSONAR
		//  do something 
	}

	submit(){
		console.info("the from date",this.selectedFromDate);
		console.info("the to date",this.selectedToDate);
	}

}
